import OddsBooster from "./OddsBooster";
import QuickAdd from "./QuickAdd";
import UpsellsBlock from "./UpsellsBlock";
import {useEffect, useState} from "@wordpress/element";
import apiFetch from "@wordpress/api-fetch";

const { __ } = window.wp.i18n;
const { registerPlugin } = window.wp.plugins;
const { ExperimentalOrderMeta } = window.wc.blocksCheckout;

export default function CartUpsells() {

	// Early return where not enabled.
	if( 'yes' !== window.checkout_v2.enable_checkout_upsells ){
		return null;
	}

	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);
	const [offers, setOffers] = useState( null );

	useEffect(() => {
		const fetchOffers = async () => {


			try {
				const data = await apiFetch({ path: '/wc/zap/v1/checkout-offers' });
				setOffers(data);
			} catch (error) {
				setError(error.message);
			} finally {
				setLoading(false);
			}
		};

		fetchOffers();
	}, []);

	return (
		<div className="zap-upsells-container">
			{loading && <div className="wc-block-components-spinner" aria-hidden="true"></div> }

			{!loading && !error && offers && (

				<>
					<div className="zap-upsells-inner-grid">
						{ offers.quick_add && (
							offers.quick_add.map( (competition) => (
								<QuickAdd competition={competition} key={competition.id} />
							))
						) }
					</div>
					{ offers.upsells && <UpsellsBlock competitions={offers.upsells} /> }
				</>
			)}

			{!loading && error && (
				<div className="zap-upsells-error">Error loading offers.</div>
			)}
		</div>
	);
}